/**
 * Infinite game mode: starts with 1 second (1000ms) of "life".
 * Each click subtracts the timing error from remaining life.
 * The game ends when life reaches 0.
 * Score is the number of successful clicks managed.
 */
export const createInfiniteMode = () => ({
  initialModeState: { remainingLife: 1000 },

  onClickUpdate: (modeState, timeArray) => {
    const lastInterval = timeArray[timeArray.length - 1] - timeArray[timeArray.length - 2];
    const error = Math.abs(lastInterval - 1000);
    return { remainingLife: Math.max(0, modeState.remainingLife - error) };
  },

  isGameOver: ({ modeState }) => modeState.remainingLife <= 0,

  computeScore: (times) => {
    const differences = times.slice(1).map((time, i) => time - times[i]);
    const absoluteErrors = differences.map(diff => Math.abs(diff - 1000));
    const mae = absoluteErrors.length > 0
      ? absoluteErrors.reduce((sum, err) => sum + err, 0) / absoluteErrors.length
      : 0;
    const avg = differences.length > 0
      ? differences.reduce((sum, diff) => sum + diff, 0) / differences.length
      : 0;
    // clickCount = number of scored intervals (excludes the start click)
    return { clickCount: differences.length, mae, avg, differences, absoluteErrors };
  },
});
